import { DateKeyEnum } from '@constants';

export const formatMappedFilters = (mappedFilters: Record<string, string>) => {
  const formatDateWithoutTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  const formatDate = (key: DateKeyEnum) =>
    mappedFilters[key] ? formatDateWithoutTime(mappedFilters[key]) : undefined;

  return {
    ...mappedFilters,
    [DateKeyEnum.START_DATE_KEY]: formatDate(DateKeyEnum.START_DATE_KEY),
    [DateKeyEnum.END_DATE_KEY]: formatDate(DateKeyEnum.END_DATE_KEY),
  };
};
